import { extractLanguagesFromProfiles, } from 'api/user-api';
import { apiV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
import { json } from '@newtontechnologies/beey-api-js-client/receivers';
const groupProfilesByLanguage = (profiles) => {
    const languages = extractLanguagesFromProfiles(profiles);
    return languages.map((locale) => ({
        locale,
        profiles: profiles.filter((p) => p.lang === locale.code),
    }));
};
export const fetchAllTranscriptionOptions = (connection) => connection.fetch()
    .url(apiV2.admin.information.transcriptionProfiles.url())
    .receive(json()
    .finally(() => 'unexpected')
    .map(groupProfilesByLanguage))
    .fetchStrict();
